import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetReplenishmentReport = (params) => {
    return async (dispatch, getState) => {
        try {
            params.search = params.search.replace(/\s/g, '');
            const { data } = DefaultApi({
                params,
                method: 'get',
                url: urls.GET_REPORT_REPLENISHMENT
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetReplenishmentReportAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetReplenishmentReport as SetGetReplenishmentReport
}